<ul tabindex="0"
    class="theme-border-secondary"
    (focus)="setupFocus()"
    role="listbox"
    #listBox
    *ngIf="responses.length > 0; else noResponses"
    [attr.aria-labelledby]="labelledBy">

  <ng-container *ngFor="let option of responses; index as i">
    <li role="option"
        id="listbox-item-{{i}}"
        #listItem
        class="item theme-border-secondary"
        [routerLink]="option.responseHref"
        tabindex="-1"
      >
      {{option.text}}
    </li>
    <li *ngIf="option.inline" class="inline-response">
      <div [innerHTML]="option.inlineResponseText"></div>
    </li>
  </ng-container>
</ul>

<ng-template #noResponses>
  <p>Sorry! This section is still under construction</p>
</ng-template>
